export class MoleculePanelOverviewHeaderMultiCancelDeleteDomainActionComponent {
    public templateUrl = require('./multi-cancel-delete-domain-action.html?external');
}
